










































































































































































import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins,
} from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import AppConsts from "@/lib/appconst";
import UserRoleTreeMixin from "./user-roleTree";

@Component
export default class CreateUser extends Mixins(AbpBase, UserRoleTreeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: any = {};
  spinShow: boolean = false;
  imageUrl: string = "";
  id: number = 0;
  isUpload: boolean = false;
  departments = [];
  titles = [];

  parentLoading: boolean = false;

  parentData: Array<any> = new Array<any>();
  treeData = [];
  searchParent_OnPress = _.debounce(
    this.searchParents,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  async searchParents(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.parentLoading = true;
    this.parentData = await this.$store.dispatch({
      type: "user/searchForSelect",
      data: {
        keyWord: keyword,
        clientCode: this.client.code,
      },
    });
    this.parentLoading = false;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }

  isHost() {
    return abp.session.multiTenancySide == abp.multiTenancy.sides.HOST;
  }
  get appRoles() {
    return AppConsts.identityUserAppRoles;
  }
  get appRoleDefault() {
    return AppConsts.identityUserAppRoleDefault;
  }
  get avatarUrl() {
    return this.imageUrl;
  }
  get client() {
    return this.$store.state.session.client;
  }

  get userNameLabel() {
    if (this.isClient()) {
      return `${this.L("UserName")}: ${_.toLower(this.client.code)}${
        this.user.userName ? this.user.userName : ""
      }`;
    } else {
      return this.L("UserName");
    }
  }

  get roles() {
    return this.$store.state.user.roles;
  }
  get clients() {
    return this.$store.state.user.clients;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.spinShow = true;
        if (this.isClient()) {
          this.user.clientCode = this.client.code;
        }
        const selectedNotes = (this.$refs[
          "tree"
        ] as any).getCheckedAndIndeterminateNodes();
        var permissionType = this.permissionType;
        const selectedChildrenNodes = _.filter(selectedNotes, function(o) {
          return o.type === permissionType;
        });
        this.user.roleIds = _.map(selectedChildrenNodes, (n) => n.key) || [];
        this.$store
          .dispatch({
            type: "user/create",
            data: this.user,
          })
          .then(() => {
            (this.$refs.userForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          })
          .finally(() => {
            this.spinShow = false;
          });
      }
    });
  }
  cancel() {
    this.user = {};
    this.imageUrl = "";
    this.isUpload = false;
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.isUpload = false;
      this.imageUrl = "";
      this.user = {};
      this.user.appRoles = [this.appRoleDefault];
      this.getTitles();
      this.getDepartments();
      this.treeData = this.initTree({
        roles: this.roles,
        userRoleIds: [],
      });
    }
  }
  getDepartments() {
    this.$store
      .dispatch({
        type: "user/getDepartmentForSelect",
        data: {},
      })
      .then((result) => {
        this.departments = result;
      });
  }
  getTitles() {
    this.$store
      .dispatch({
        type: "user/getTitleForSelect",
        data: {},
      })
      .then((result) => {
        this.titles = result;
      });
  }
  handleBeforeUpload(file) {
    const fileExt = file.name
      .split(".")
      .pop()
      .toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("user/uploadAvatar", data).then((res) => {
        this.user.avatarUrl = res;
        this.imageUrl = Util.getAppUrlImage(res);
        this.isUpload = true;
      });
    }

    return false;
  }
  handleRemoveAvatar() {
    this.isUpload = false;
    this.imageUrl = "";
    this.user.avatarUrl = "";
  }
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error(this.L("ConfirmPasswordMsg")));
    } else if (value !== this.user.password) {
      callback(new Error(this.L("ConfirmPasswordNotMatch")));
    } else {
      callback();
    }
  };
  userRule = {
    userName: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("UserName")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    surname: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Surname")),
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Password")),
        trigger: "blur",
      },
    ],
    confirmPassword: { validator: this.validatePassCheck, trigger: "blur" },
  };
}
